(function ($) {

    var Cookies = require('cookies-js');
    console.log(Cookies);

    jQuery.fn.surveyor = function (options) {
        var $that = this;

        return this.each(function () {

            $('.radio-verification', this).click(function () {
                if (this.value == 'disagree') {
                    $(this).parents('.stratosfear-score-form').find('.stratosfear-override').addClass('override')
                } else {
                    $(this).parents('.stratosfear-score-form').find('.stratosfear-override').removeClass('override')
                }
            });

            $('.gsection', this).each(function (e, elem) {

                var section = $(this);
                var key = section.find('.gsection_title').text()
                section.addClass('collapsable');
                section.nextAll('.gfield').not('.gsection').attr('data-collapsable-item', section.index())

                section.click(function () {

                    var $this = $(this)

                    if ($this.hasClass('closed')) {
                        $this.removeClass('closed')
                        Cookies.expire(key)
                        $('.gfield', $that).filter(function () {
                            return $(this).data("collapsable-item") == section.index()
                        }).removeClass('closed');
                    } else {
                        $this.addClass('closed')
                        Cookies.set(key, 'closed', {
                            expires: Infinity
                        })
                        $('.gfield', $that).filter(function () {
                            return $(this).data("collapsable-item") == section.index()
                        }).addClass('closed');
                    }

                })
            }).each(function () {

                var section = $(this);
                var key = section.find('.gsection_title').text()

                if (Cookies.get(key) == 'closed') {
                    section.addClass('closed')
                    $('.gfield', $that).filter(function () {
                        return $(this).data("collapsable-item") == section.index()
                    }).addClass('closed');
                }
            })

        })

    }


    var cookie = require('cookie');

    $(window).bind("load", function() {
        $('.mustload').remove();
            var not_answered_yet = $(".not-answered-yet:visible:first").focus()
            if(not_answered_yet.length > 0)
            {
                $('html, body').animate({
                scrollTop: (not_answered_yet.offset().top -20) + 'px'
            }, 'slow');
            }
     });

    $(document).ready(function () {


        $('.sf-text-suggest').on('click','li > a', function(){
            
            let id = $(this).data('target');

            let t = $('[name="stratosfearNotes['+id+']"]');

            t.val(t.val()  + (t.val()!='' ? '\r' : '') + $(this).text());

        });


        setTimeout(function () {
            $('.ginput_container_date img.ui-datepicker-trigger').each(function () {
                $(this).attr('src', StratosFear.calendar_icon)
            })
        }, 50);

        $('select.gfield_select', '.stratosfear-entry-form').change(function () {
            var $field = $(this);
            var field_name = $field.attr('name');
            var field_id = field_name.replace(/\D+/g, '');
            if (field_id && StratosFear.score_settings.scores[field_id][$field.val()]) {
                $('[name="score-box[' + field_id + ']"]').val(StratosFear.score_settings.scores[field_id][$field.val()])
            }
        })

        $('select.gfield_select', '.stratosfear-score-form').change(function () {
            var $field = $(this);
            var field_name = $field.attr('name');
            var field_id = field_name.replace(/\D+/g, '');
            if (field_id && StratosFear.score_settings.scores[field_id][$field.val()]) {
                $('[name="sf-score-box[' + field_id + ']"]').val(StratosFear.score_settings.scores[field_id][$field.val()])
            }
        })

        //Question Numbering
        let start_numbering = $('.sf_start_numbering');
        let question_number = 0;
        let condition_number = 0;
        
        $('.gfield_label', $('.gfield').slice(start_numbering.index())).each(function(){

            let $this = $(this);

            if ($this.hasClass('has_condition')) {                
                condition_number++
                $(this).prepend('<span class="question-number">'+question_number+'.'+condition_number+'.)</span> ')
            }else{
                condition_number = 0;
                question_number++;
                $(this).prepend('<span class="question-number">'+question_number+'.)</span> ')
            }

            
        })


        var chart = document.getElementById("businessChart");

        if (chart) {
            chartInit(chart);
        }

        var stratos_form_container = $('.survey-form-container').surveyor();

    })

    function chartInit(chartObj) {
        var businessChart = new Chart(chartObj, {
            type: 'line',
            data: {
                labels: BusinessGraph.labels,
                datasets: [{
                    label: 'STRATOSFEAR Business Dynamics Index',
                    data: BusinessGraph.scores,
                    borderWidth: 1,
                    fill: false,
                    lineTension: 0,
                    borderColor: '#e16309'
                }]
            },
            options: {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0,
                            beginAtZero: true,
                            stepSize: 10,
                            callback: function (value, index, values) {
                                return value + '.00%';
                            },
                            max: 100
                        }
                    }]
                }
            }
        });
    }


})(jQuery)


// WEBPACK FOOTER //
// ./wp-content/plugins/stratosfear-survey/assets/js_dev/survey.js